// material
import { Container, Paper, Tabs, Tab, Alert } from '@mui/material'
import { useState } from 'react'
import Page from '../components/Page'
import { EncryptData, DecryptData } from '../utils/encryptDecrypt'
import DashboardApp from './DashboardApp'
import ReportApp from './ReportApp'
// ----------------------------------------------------------------------

export default function FavouritesApp() {
  const [favourite, setFavourite] = useState(DecryptData(localStorage.getItem('selectedFavouriteTab')) ?? 'dashboard')

  const handleSwitchFavorite = (e) => {
    setFavourite(e?.target?.attributes?.index?.value)
    localStorage.setItem('selectedFavouriteTab', EncryptData(e?.target?.attributes?.index?.value ?? ''))
  }

  return (
    <Page title="Extramarks | Report-Engine">
      <Container className="table_max_width main-container" >
        <Paper square className="favourite-tabs">
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            aria-label="Tabs"
            value={favourite}
            onChange={(e) => handleSwitchFavorite(e)}
          >
            <Tab label="Dashboards" value="dashboard" index="dashboard" />
            <Tab label="Reports" value="report" index="report" />
          </Tabs>
        </Paper>

        {favourite === 'dashboard' ? (
          <DashboardApp favouriteFilter={true} />
        ) : favourite === 'report' ? (
          <ReportApp favouriteFilter={true} />
        ) : (
          <Alert severity="error">No Content Available!</Alert>
        )}
      </Container>
    </Page>
  )
}
